import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';

class AdjustOrderController extends Controller {
  connect() {
    this.renumber();
  }

  moveItemUp({ currentTarget }) {
    const item = AdjustOrderController.getItem(currentTarget);

    this.moveItem(item, 'up');
  }

  moveItemDown({ currentTarget }) {
    const item = AdjustOrderController.getItem(currentTarget);

    this.moveItem(item, 'down');
  }

  moveItem(item, direction) {
    const $item = $(item);
    const $sibling = $item[direction === 'up' ? 'prev' : 'next']();

    if ($sibling.length) {
      $sibling[direction === 'up' ? 'before' : 'after']($item);
      this.renumber();
    }
  }

  renumber() {
    const items = toArray(this.itemTargets);

    items.forEach((item, index) => {
      const numberOutput = item.querySelector('[data-target="adjust-order.number"]');

      numberOutput.innerText = index + 1;
    });
  }

  static getItem(target) {
    return target.closest('[data-target="adjust-order.item"]');
  }
}

AdjustOrderController.targets = [
  'item',
  'number',
];

export default AdjustOrderController;
